import Vue from 'vue'

export const setMessages = (state, payload) => {
  Vue.set(state, 'messages', payload)
}
